<template>
    <div class="animated fadeIn">
        <loading :active.sync="disabledField"></loading>
        <b-row class="text-right">
            <b-col cols="6" sm="4" md="2" class="mb-3">
                <b-button size="sm" block v-bind:variant="btnConnectClass()" v-on:click="changeWidgetStatus()" :disabled="btnChangeDisabled()">{{btnConnectText()}}</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6">
                <b-card>
                    <div slot="header"><i class="icon icon-plus"></i><strong> Добавить тег</strong> </div>
                        <b-form-group
                        label="Хэштег сделки"
                        label-for="hashtag"
                        :label-cols="2"
                        :horizontal="true">
                            <b-form-input  id="hashtag" type="text" placeholder="#хэштег" v-model="tag"></b-form-input>
                        </b-form-group>
                        <b-form-group
                        label="Цвет сделки"
                        label-for="color"
                        :label-cols="2"
                        :horizontal="true">
                            <swatches v-model="color" popover-to="right" id="color" swatch-size="24"></swatches>
                        </b-form-group>
                    <div slot="footer">
                        <b-button type="submit" size="sm" variant="primary" v-on:click="addTag()" :disabled="!widget.isActive"><i class="fa fa-dot-circle-o"></i> Добавить</b-button>
                    </div>
                </b-card>

                <b-card :header="caption">
                    <b-table :small="true" responsive="sm" :items="settings" :current-page="currentPage" :fields="fields">
                        <template slot="color" slot-scope="data" >
                            <b-badge v-bind:style="{ 'background-color': data.item.color}">{{data.item.tag}}</b-badge>
                        </template>
                        <template slot="edit" slot-scope="data" >
                            <swatches v-model="data.item.color" popover-to="right" @input="saveSettings" swatch-size="24"></swatches>
                        </template>
                        <template slot="delete" slot-scope="data" >
                            <b-button right size="sm" variant="danger" v-on:click="removeTag(data.item)"><i class="fa fa-minus"></i></b-button>
                        </template>
                        
                    </b-table>
                    <nav><b-pagination :total-rows="totalRows" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/></nav>                
                </b-card>
            </b-col>

            <b-col md="6">
                <b-card header-tag="header" footer-tag="footer">
                    <div slot="header"> <i class="icon-notebook icons"></i><strong> Описание</strong></div>
                    <p>
                        Виджет позволяет изменять цвет фона карточки сделки в зависимости от тегирования сделки. Цветные карточки легче считываются при беглом обзоре воронки.
                    </p>
                </b-card>
            </b-col>
        </b-row>
  </div>
</template>

<script>
    import Swatches from 'vue-swatches'
    import "vue-swatches/dist/vue-swatches.min.css"
    import WidgetsService from '@/services/WidgetsService'
    import widgetEvents from '@/views/widgets/Widget';

    export default {
        mixins: [
            widgetEvents,
        ],
        components: { Swatches }, 
        name: 'LeadColor',
        data () {
            return {
                widget:  { isActive : false },
                widgetId: '5cbf063966ded3251335b883',
                settings: [],
                color: '#b9f5f1',
                currentPage: 1,
                caption: '<i class="icon icon-list"></i><strong> Список тегов</strong>',
                tag : '',
                fields: [
                    {key: 'color', label: 'Цвет'},
                    {key: 'edit', label: ''},
                    {key: 'delete', label: ''},
                ],
                disabledField: false,
                onLoad : false,
            }
        },
        computed: {
            totalRows: function () { return this.getRowCount() },
        },
        methods: {
            getRowCount: function () {
                if(this.settings) return this.settings.length
                else return 0;
            },
            addTag () {
                if(this.tag != '') this.settings.push({color: this.color, tag: this.tag });
                else alert('Вы не ввели название тега');
                this.saveSettings();
            }, 
            removeTag(item) {
                this.settings.splice(this.settings.indexOf(item), 1);
                this.saveSettings();
            },
        }
    };
    
</script>
<style>
    .vue-swatches__trigger {
        width: 32px !important;
        height: 32px !important;
    }
</style>